import type {HelpFile} from '../../types/help'
import {WizardStepScopeTestIds} from '../../../testids/WizardStepScopeTestIds'

export const wizardStepScopeHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [WizardStepScopeTestIds.scopeCard]:
            'Legen Sie fest, welche Zuweisungen diese Richtlinie zertifiziert — über strukturierte Bedingungen oder einen CEL-Ausdruck.',
        [WizardStepScopeTestIds.scopeConditionsLabel]:
            'Strukturierter, regelbasierter Geltungsbereich: Zeilen aus Feld / Operator / Wert. Leer lassen, um alle aktiven Zuweisungen zu zertifizieren.',
        [WizardStepScopeTestIds.scopeExpressionLabel]:
            'Ein CEL-Ausdruck für die erweiterte Geltungsbereich-Filterung mit Feldvervollständigung.',
        [WizardStepScopeTestIds.previewSection]:
            'Live-Vorschau, wer für die aktuellen Bedingungen oder den Ausdruck im Geltungsbereich liegt.',
        [WizardStepScopeTestIds.scopeModeToggle]: null,
        [WizardStepScopeTestIds.btnScopeModeConditions]: null,
        [WizardStepScopeTestIds.btnScopeModeExpression]: null,
        [WizardStepScopeTestIds.expressionEditor]: null,
        [WizardStepScopeTestIds.expressionErrorBanner]: null,
        [WizardStepScopeTestIds.dialogSwitchMode]: null,
    },
}
